import type { MarketplaceProfileAssetRef } from '@foodfluence/shared';
import { getDownloadURL, ref } from 'firebase/storage';
import { storage } from '../../../../../firebase';
import { padTopSlotsFromResolved } from './marketplaceProfileAssets';
import type { LocalCreatorsProfileImage, TopContentSlotEntry } from '../types';

async function resolveAssetDisplayUrl(a: MarketplaceProfileAssetRef): Promise<string> {
  if (a.downloadUrl) {
    return a.downloadUrl;
  }
  if (a.storagePath) {
    return getDownloadURL(ref(storage, a.storagePath));
  }
  return '';
}

export async function loadProfileImageFromRef(
  profileImage: MarketplaceProfileAssetRef | null | undefined
): Promise<LocalCreatorsProfileImage | null> {
  if (!profileImage || profileImage.type !== 'photo' || !profileImage.id || !profileImage.storagePath) {
    return null;
  }
  const url = await resolveAssetDisplayUrl(profileImage);
  if (!url) {
    return null;
  }
  return {
    id: profileImage.id,
    storagePath: profileImage.storagePath,
    url,
    contentType: profileImage.contentType,
  };
}

export async function loadTopSlotsFromAssets(
  assets: MarketplaceProfileAssetRef[] | undefined
): Promise<(TopContentSlotEntry | null)[]> {
  const list = assets ?? [];
  if (list.length === 0) {
    return [null, null, null];
  }
  const resolved: TopContentSlotEntry[] = [];
  for (const a of list) {
    const url = await resolveAssetDisplayUrl(a);
    if (!url) {
      continue;
    }
    resolved.push({
      id: a.id,
      storagePath: a.storagePath,
      url,
      isVideo: a.type === 'video',
      contentType: a.contentType,
      associatedBrand: a.associatedBrand,
      caption: a.caption,
    });
  }
  return padTopSlotsFromResolved(resolved);
}
